const QUERY_PARAM_SEGMENT_DEBUG = "segment_debug_on";

const urlParams = new URLSearchParams(window.location.search);

export function useSegmentDebug(): boolean {
  return !!urlParams.get(QUERY_PARAM_SEGMENT_DEBUG);
}
